import { StandardTextFieldProps, TextField, styled, Theme } from "@mui/material";
import React from "react";
import { ICustomerPortalTheme } from "../../entities/CustomerPortalTheme";

interface ISearchBarProps extends StandardTextFieldProps {
  isMobile: boolean;
  searchExpanded: boolean;
  onClick: any;
  theme?: Theme & ICustomerPortalTheme;
}

const Wrapper = styled(
  React.forwardRef<HTMLDivElement, ISearchBarProps>((props: ISearchBarProps, ref) => (
    <TextField ref={ref} {...props} />
  )),
  { shouldForwardProp: prop => prop !== "isMobile" && prop !== "searchExpanded" }
)(props => ({
  transition: ".5s ease-in-out",
  "& .MuiInputBase-formControl": {
    backgroundColor: props.theme.modernSecondaryButtonColor,
    border: `${props.theme.modernButtonBorderWidth}px solid ${props.theme.modernSecondaryButtonBorderColor}`,
    borderRadius: props.theme.modernButtonBorderRadius,
    color: props.theme.modernBodyFontColor,
    fontSize: props.theme.modernBodyFontSize,
    fontWeight: props.theme.modernBodyFontWeight,
    fontFamily: props.theme.modernBodyFontFamily,
    lineHeight: props.theme.modernBodyFontLineHeight,
    letterSpacing: props.theme.modernBodyFontLetterSpacing,
    height: "30px",
    minWidth: "230px",
    padding: "5px 15px",
    width: "210px",
    transition: ".5s ease-in-out",
  },
  "& input::placeholder": {
    color: props.theme.modernBodyFontColor,
    opacity: ".5",
  },

  "& fieldset": {
    display: "none",
  },

  ...(props.isMobile && {
    "& .MuiInputBase-formControl": {
      backgroundColor: props.theme.modernSecondaryButtonColor,
      border: `${props.theme.modernButtonBorderWidth}px solid ${props.theme.modernSecondaryButtonBorderColor}`,
      borderRadius: props.theme.modernButtonBorderRadius,
      color: props.theme.modernBodyFontColor,
      fontSize: props.theme.modernBodyFontSize,
      fontWeight: props.theme.modernBodyFontWeight,
      fontFamily: props.theme.modernBodyFontFamily,
      lineHeight: props.theme.modernBodyFontLineHeight,
      letterSpacing: props.theme.modernBodyFontLetterSpacing,
      height: "30px",
      padding: "5px 15px",
      transition: ".5s ease-in-out",

      minWidth: "42px", //This changes
      width: "42px", // and this changes
    },
    "& input": {
      display: "none",
    },
  }),

  "@media screen and (max-width: 768px)": {
    minWidth: "unset",
    marginLeft: "0",
    display: "flex",
    alignItems: "end",
    width: "max-content",
    height: "max-content",
  },

  ...(props.isMobile &&
    props.searchExpanded && {
      "&": {
        width: "100%",
      },
      "& input": {
        display: "block",
      },
      "& .MuiInputBase-formControl": {
        backgroundColor: props.theme.modernSecondaryButtonColor,
        border: `${props.theme.modernButtonBorderWidth}px solid ${props.theme.modernSecondaryButtonBorderColor}`,
        borderRadius: props.theme.modernButtonBorderRadius,
        color: props.theme.modernBodyFontColor,
        fontSize: props.theme.modernBodyFontSize,
        fontWeight: props.theme.modernBodyFontWeight,
        fontFamily: props.theme.modernBodyFontFamily,
        lineHeight: props.theme.modernBodyFontLineHeight,
        letterSpacing: props.theme.modernBodyFontLetterSpacing,
        height: "30px",
        padding: "5px 15px",
        transition: ".5s ease-in-out",

        minWidth: "100%",
        width: "100%",
      },
    }),
}));

export const SearchInput = React.forwardRef<HTMLDivElement, ISearchBarProps>(
  ({ isMobile, searchExpanded, ...props }: ISearchBarProps, ref): React.JSX.Element => {
    return <Wrapper isMobile={isMobile} ref={ref} searchExpanded={searchExpanded} {...props} />;
  }
);
